import { Component, Input, OnChanges, OnInit } from '@angular/core';

import { PayrollTypeBaseEnum } from '@shared-enums/time.enum';

import { IDayGridData, ITemplateItem } from './payroll-day-grid.model';

@Component({
  selector: 'payroll-day-grid',
  templateUrl: './payroll-day-grid.component.html',
  styleUrl: './payroll-day-grid.component.css',
  standalone: false,
})
export class PayrollDayGridComponent implements OnInit, OnChanges {
  @Input() public data!: IDayGridData;

  public statefulTemplateArray: ITemplateItem[] = [];

  private readonly templateHelper: ITemplateItem[] = [
    {
      key: PayrollTypeBaseEnum.Straight,
      name: 'straight',
      value: 0,
    },
    {
      key: PayrollTypeBaseEnum.Overtime,
      name: 'over',
      value: 0,
    },
    {
      key: PayrollTypeBaseEnum.Double,
      name: 'double',
      value: 0,
    },
    // {
    //   key: 'n',
    //   name: 'nonbill'
    // },
    // {
    //   key: 'pto',
    //   name: 'pto'
    // }
  ];

  ngOnChanges() {
    this.statefulTemplateArray = this.grantStateToTemplateHelper(this.data);
  }

  ngOnInit(): void {
    this.statefulTemplateArray = this.grantStateToTemplateHelper(this.data);
  }

  private grantStateToTemplateHelper(data: IDayGridData): ITemplateItem[] {
    const tempArr: ITemplateItem[] = [];

    this.templateHelper.forEach((element) => {
      if (data[element.key] > 0) {
        element.value = data[element.key];
        tempArr.push(element);
      }
    });
    return tempArr;
  }
}
